export const DB_CONFIG = {
  apiKey: "AIzaSyBXgHzw0gd89Fs3X3-5dBpdKMizzXJy72M",
  authDomain: "raymond-portfolio.firebaseapp.com",
  databaseURL: "https://raymond-portfolio.firebaseio.com",
  projectId: "raymond-portfolio",
  storageBucket: "raymond-portfolio.appspot.com",
  messagingSenderId: "59646841705"
}



// WEBPACK FOOTER //
// ./src/Config.js